const state = () => ({
    organizations: []
});

const mutations = { 
    setOrganizations: (state,data) => {
        state.organizations = data
    }
}

const getters = {
    getOrganizations: state => state.organizations
}

const actions = {
    setOrganizationsAction({commit}, data) {
        commit('setOrganizations', data);
    }
}

export default {
    state, mutations, actions, getters
}